/* eslint-disable indent */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Header from '@core_modules/theme/components/header/components/v1/adaptive/desktop';
import cx from 'classnames';

import { BREAKPOINTS } from '@core/theme/vars';

const HeaderV1 = (props) => {
    const {
        //
        storeConfig,
        handleSearch,
        setValue,
        data,
        loading,
        t,
        isLogin,
        customer,
        handleLogout,
        deviceWidth,
        appName,
        installMessage,
        ...other
    } = props;

    const isGlobalPromoEnabled = storeConfig?.header_animation_enable === '1';

    // eslint-disable-next-line consistent-return
    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            // handle sticky
            if (storeConfig && storeConfig.pwa && storeConfig.pwa.enabler_sticky_header) {
                let isDesktop = false;
                // eslint-disable-next-line no-unused-vars
                let isTablet = false;
                let isMobile = false;
                if (window.innerWidth >= BREAKPOINTS.xl) {
                    isDesktop = true;
                } else if (window.innerWidth >= BREAKPOINTS.md) {
                    isTablet = true;
                } else {
                    isMobile = true;
                }
                // apply on tablet and desktop only
                // if (!isMobile) {
                    const header = document.querySelector('header');
                    const mainContent = document.querySelector('header ~ main');
                    const innerHeader = document.querySelector('#header-inner');
                    const globalPromo = document.querySelector('#global-promo-container');
                    // eslint-disable-next-line max-len
                    const headerContent = document.querySelector('#header-inner .header-wrapper-main') || document.querySelector('#sticky-header .header-wrapper-main');
                    const sticky = document.querySelector('#sticky-header');
                    // eslint-disable-next-line no-unused-vars
                    let headerHeight = 0;
                    // eslint-disable-next-line no-unused-vars
                    let globalPromoheight = 0;
                    // eslint-disable-next-line no-unused-vars
                    let topHeaderheight = 0;
                    let midHeaderheight = 0;
                    let bottomHeaderheight = 0;
                    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    const handleScroll = () => {
                        const scrollTopPosition = window.pageYOffset || document.documentElement.scrollTop;
                        headerHeight = header.offsetHeight;
                        globalPromoheight = document.querySelector('#global-promo-message')?.offsetHeight;
                        topHeaderheight = isDesktop || isMobile
                            ? document.querySelector('.desktop-header .top-header')?.offsetHeight
                            : document.querySelector('#top-header')?.offsetHeight || 0;
                        midHeaderheight = isDesktop || isMobile
                            ? document.querySelector('.desktop-header .middle-header')?.offsetHeight
                            : document.querySelector('.tablet-header .middle-header-tablet')?.offsetHeight || 0;
                        bottomHeaderheight = isDesktop || isMobile ? document.querySelector('.desktop-header .bottom-header')?.offsetHeight : 0;

                        if (scrollTopPosition > lastScrollTop) {
                            if (scrollTopPosition > 0) {
                                sticky.style.top = `-${0}px`;
                                if (sticky.querySelector('#global-promo-message') == null && isGlobalPromoEnabled) {
                                    sticky.appendChild(globalPromo);
                                }
                                sticky.appendChild(headerContent);
                                header.style.height = `${0}px`;
                                sticky.style.top = 0;
                                mainContent.style.paddingTop = `${midHeaderheight + bottomHeaderheight}px`;
                                mainContent.style.position = 'relative';
                            }
                        } else if (scrollTopPosition < lastScrollTop) {
                            if (scrollTopPosition > 0) {
                                sticky.style.top = `-${0}px`;
                            } else {
                                sticky.style.top = '-500px';
                                if (isGlobalPromoEnabled) {
                                    innerHeader.appendChild(globalPromo);
                                }
                                innerHeader.appendChild(headerContent);
                                innerHeader.style.marginTop = 0;
                                header.style.height = 'initial';
                                mainContent.style.paddingTop = `${0}px`;
                                mainContent.style.position = 'relative';
                            }
                        }
                        lastScrollTop = scrollTopPosition <= 0 ? 0 : scrollTopPosition;
                    };
                    window.addEventListener('scroll', handleScroll);
                    return () => window.removeEventListener('scroll', handleScroll);
                // }
            }
        }
    }, []);

    return (
        <>
            <div
                id="sticky-header"
                className={cx(
                    'top-[-500px]', 'bg-neutral-white',
                    // 'transition-all', 'duration-500', 'ease-in-out',
                    'z-[999]', 'w-[100%]', {
                    '!fixed': storeConfig && storeConfig.pwa && storeConfig.pwa.enabler_sticky_header,
                    '!relative': storeConfig && !storeConfig.pwa && !storeConfig.pwa.enabler_sticky_header,
                    },
                )}
            />
            <div id="header-inner" className={cx('bg-neutral-white')}>
                <div className={cx('header-wrapper-main')}>
                    <div className="header-main">
                        <Header
                            t={t}
                            storeConfig={storeConfig}
                            isLogin={isLogin}
                            setValue={setValue}
                            handleSearch={handleSearch}
                            dataMenu={data}
                            loadingMenu={loading}
                            handleLogout={handleLogout}
                            customer={customer.customer}
                            deviceWidth={deviceWidth}
                            {...other}
                        />
                    </div>
                </div>
                <style jsx>
                    {`
                        .header-wrapper-main {
                            background-color: ${storeConfig && storeConfig.pwa && storeConfig.pwa.background_color};
                        }
                        .menu-category {
                            width: fit-content;
                            display: block;
                        }
                    `}
                </style>
                <style global jsx>
                    {`
                        .hidden-submenu {
                            display: none !important;
                            transition: display 1s ease;
                        }
                        .header-small {
                            top: -45px !important;
                        }
                        @media (min-width: 1250px) {
                            .header-small {
                                height: 75px !important;
                            }
                            .hidden-submenu {
                                display: none !important;
                                transition: display 1s ease;
                            }
                        }
                    `}
                </style>
            </div>
        </>
    );
};

export default HeaderV1;
